import React, { useContext } from 'react';
import { AuthContext } from '../lib/auth';
import { Link } from 'react-router-dom';
import { Button, Container, Row, Col } from 'react-bootstrap';
import SignIn from './auth/signin';
import Logo from '../../src/images/logo.png';
import WeChatLogo from '../../src/images/wechat.png';

const App = () => {
  const auth = useContext(AuthContext);

  return (
    <Container className="h-100">
      <Row className="h-100">
        <Col xl={6} className="mt-5">
          <h1>
            <img src={Logo} alt="Weマーケ!" />
            へようこそ
          </h1>
          <Row className="mt-5 d-flex align-items-center">
            <Col xs={3}>
              <img src={WeChatLogo} alt="WeChatロゴ" className="img-fluid" />
            </Col>
            <Col style={{ lineHeight: '170%' }}>
              TwitterやInstagramでの投稿を、中国最大のSNS「WeChat」に投稿。
              <br />
              また、翻訳も自動で行い、中国語で投稿します。
            </Col>
          </Row>
          <div className="text-center mt-5">
            {auth.currentUser && (
              <Button
                as={Link}
                to="/auth/mypage"
                variant="primary"
                className="btn-lg w-100"
              >
                マイページ
              </Button>
            )}
            {!auth.currentUser && (
              <>
                <div className="mt-4 px-4">
                  <SignIn />
                </div>
              </>
            )}
          </div>
          <p className="text-right">R2 事業再構築</p>
        </Col>
        <Col className="">
        </Col>
      </Row>
    </Container>
  );
};

export default App;
